import { createFileRoute } from "@tanstack/react-router";

import { CustomPagePage } from "../../../../areas/seller/more/customPage/CustomPagePage";

export const Route = createFileRoute("/app/_seller/more/custom-page")({
  component: CustomPagePage,
});
